/**
 * A text field as an image alt: tags stripped and whitespace collapsed, so a banner headline typed
 * with line breaks doesn't end up as a multi-line alt. Empty when there's nothing to say — callers
 * fall through to their next candidate, and a final '' marks the image as decorative.
 */
export function toAltText(value: unknown): string {
    if (typeof value !== 'string') return '';
    return value.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
}
